// extracted by mini-css-extract-plugin
export default {"Dialog":"GlobalUserNavDrawer-module__Dialog--eDQZB"};